import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class AttackProfileAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'attackProfile';

	getResult(id) {
		let request = {
			url: `${this.getAPIUrl()}/${id}/result`
		};

		return httpClient.getAsync(request);
	}
}

export default new AttackProfileAPI();
